









import Vue from 'vue'
import Component from 'vue-class-component'
import BraintreeDropin from 'braintree-web-drop-in'
import { Emit, Prop, Watch } from 'vue-property-decorator'

@Component({
    
})
export default class DropinContainer extends Vue {
    @Prop(Boolean) readonly anonymous!: boolean;
    dropin : BraintreeDropin.Dropin | undefined | null = null
    loadCount = 0;

    get loaded()
    {
        return !this.loading;
    }

    get loading()
    {
        return this.loadCount > 0;
    }

    set loading(value : boolean)
    {
        if (value)
        {
            //console.error('incr');
            this.loadCount++;
        }
        else
        {
            //console.error('decr');
            this.loadCount--;
        }
    }

    errors : {error : string}[] = [];

    get isSubscribed()
    {
        return this.user.isSubscribed;
    }

    async init_dropin(attempts : number)
    {
        if (this.dropin) return;

        this.loading = true;
        let ref = (this.$refs as any).dropinTarget;
        if (!ref)
        {
            this.loading = false;
            if (attempts > 20)
            {
                this.errors.length = 0;
                this.errors.push({error: "Failed to load payment component.  Please try again later."});
                return;
            }
            this.$nextTick(()=>{
                this.init_dropin(attempts + 1);
            })
            return;
        }

        try
        {
            let resp = await this.$http.get(this.anonymous ? 'payments/subscription/token/anonymous' : 'payments/subscription/token');
            BraintreeDropin.create({
                vaultManager: false,
                authorization: resp.data.token,
                container: ref,
                card: {
                    cardholderName: {
                        required: true
                    },
                    
                    overrides: {}
                }
            }, 
            (error, dropin)=>
            {
                if (error)
                {
                    console.error('Failed');
                    console.error(error);
                    this.errors.length = 0;
                    this.errors.push({
                        error: 'Error initializing payment panel: ' + (error as any)
                    });
                    return;
                }
                // console.log(dropin);
                this.dropin = dropin;
                this.$emit('loaded', dropin);
                if (dropin)
                {
                    dropin.on("paymentMethodRequestable", (payload) =>
                    {
                        this.$emit("payment-method-changed", payload.paymentMethodIsSelected);
                    });

                    dropin.on("paymentOptionSelected", (payload) =>
                    {
                        this.$emit("payment-method-changed", true);
                    });
                }
            });
        }
        catch(ex)
        {
            console.error(ex);
            this.errors.length = 0;
            this.errors.push({
                error: 'Failed to connect to payment backend'
            });
        }
        this.loading = false;
    }

    mounted()
    {
        this.init_dropin(0);
    }

    beforeDestroy()
    {
        if (this.dropin)
        {
            this.dropin.teardown();
        }
    }
}
